import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import { templateKeys } from './useTemplates';

/**
 * Delete (soft delete) a template mutation
 * Removes from cache and invalidates lists on success
 *
 * @returns Mutation object with mutate function
 *
 * @example
 * const deleteTemplate = useDeleteTemplate();
 * deleteTemplate.mutate(templateId);
 */
export function useDeleteTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/api/templates/${id}`);
      return id;
    },
    onSuccess: (deletedId) => {
      // Remove from detail cache
      queryClient.removeQueries({ queryKey: templateKeys.detail(deletedId) });
      // Invalidate lists to refetch
      queryClient.invalidateQueries({ queryKey: templateKeys.lists() });
    },
  });
}
